import { Action, createAction } from 'redux-actions';
import { Leg } from '../../types';

export const SET_LEGS = 'SET_LEGS';

export type LegsAction = Action<Leg[]>;

export const setLegs = createAction(SET_LEGS, (legs: Leg[]) => legs);
